export default ".fancy-box[data-v-d7f2bd14] { z-index: 9999999999;\n}\n"